export default __webpack_public_path__ + "static/media/bdswissGlobalReal_downloadMT4.17d2b3dd.png";